module.exports = __webpack_public_path__ + "img/mobile-features-swap.c3fbf1dc.svg";